const getFormValidator = async (form, addressTemplates, validationMode)=>{
    const [{ FormValidator }, { MultilineAddressToolkit }] = await Promise.all([
        import(/* webpackChunkName: "form-validator" */ '@wix/form-validator'),
        import(/* webpackChunkName: "form-multiline-address" */ '@wix/form-multiline-address')
    ]);
    if (addressTemplates?.length) {
        const addressForms = addressTemplates.map((template)=>template.template);
        const addressToolkit = new MultilineAddressToolkit(addressForms);
        return new FormValidator([
            form
        ], validationMode, false, addressToolkit.getFormForValidation, addressToolkit.normalizeEmptyValues, true);
    }
    return new FormValidator([
        form
    ], validationMode, undefined, undefined, undefined, true);
};
export const validate = async (form, values, addressTemplates, validationMode)=>{
    if (!form.id) {
        return;
    }
    const formValidator = await getFormValidator(form, addressTemplates, validationMode);
    return formValidator.validate(form.id, values);
};
export const validateFields = async (form, values, addressTemplates, validationMode)=>{
    if (!form.id) {
        return;
    }
    const formValidator = await getFormValidator(form, addressTemplates, validationMode);
    return formValidator.validateFields(form.id, values);
};

//# sourceMappingURL=validation.js.map